import { MY_TEAM_ADD_USER, MY_TEAM_ALL_ROLES, MY_TEAM_ALL_ROLES_SUCCESSFUL, MY_TEAM_ADD_USER_SUCCESSFUL, MY_TEAM_ADD_USER_FAILED } from "./actionTypes"

const initialState = {
    loader: false,
    buttonLoader: false,
    allRoles: null,
    newUserMyTeam: null,
    successMessage: null,
    errorMessage:null  
}

const addUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case MY_TEAM_ALL_ROLES:
            state = {
                ...state,
                loader: true,
                allRoles:null,
                newUserMyTeam: null,
                successMessage: null,
                errorMessage:null
            }
            break
        case MY_TEAM_ALL_ROLES_SUCCESSFUL:
            state = {
                ...state,
                loader: false,
                allRoles: action.payload,
                successMessage: null,
                errorMessage:null                
            }
            break
        case MY_TEAM_ADD_USER:
            state = {
                ...state,
                buttonLoader:true,
                newUserMyTeam: action.payload,
                successMessage: null,
                errorMessage:null
            }
            break
        case MY_TEAM_ADD_USER_SUCCESSFUL:
            state = {
                ...state,
                buttonLoader:false,
                successMessage: action.payload,
                errorMessage:null
            }
            break
        case MY_TEAM_ADD_USER_FAILED:
            state = {
                ...state,
                buttonLoader:false,
                successMessage: null,
                errorMessage:action.payload
            }
            break

        default:
            state = { ...state }
            break
    }
    return state
}
export default addUserReducer